import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'

function getMessage(messages) {
  let message = ' '
  for (let index = 0; index < messages.length; index++) {
    const element = messages[index]
    if (typeof element === 'string' || element instanceof String) {
      message = message + element
    } else {
      message = message + element.message
    }
  }

  return message
}

export class ErrorDisplay extends React.Component {
  render() {
    const { error } = this.props
    if (!error) {
      return <></>
    }
    const { response } = error
    if (!response) {
      return (
        <ReactBootstrap.Alert variant={'danger'}>
          <p style={{ wordBreak: 'break-all', padding: '0px', margin: '0px' }}>
            {error}
          </p>
        </ReactBootstrap.Alert>
      )
    }
    const { data } = response
    if (data) {
      let errorListItems = []
      const keys = Object.keys(data)
      keys.forEach((key) => {
        let message = ''
        if (Array.isArray(data[key])) {
          message = (
            <p
              style={{ wordBreak: 'break-all', padding: '0px', margin: '0px' }}
            >
              <strong>
                {key.toUpperCase() !== 'NON_FIELD_ERRORS'
                  ? key.toUpperCase()
                  : ''}
              </strong>
              {getMessage(data[key])}
            </p>
          )
        } else {
          message = data[key]
        }
        errorListItems.push(<li>{message}</li>)
      })

      return (
        <ReactBootstrap.Alert variant={'danger'}>
          <ul className={'list-unstyled'}>{errorListItems}</ul>
        </ReactBootstrap.Alert>
      )
    }
    if (error.isAxiosError) {
      return (
        <ReactBootstrap.Alert variant={'danger'}>
          <p>Something went wrong.</p>
        </ReactBootstrap.Alert>
      )
    } else {
      return <p></p>
    }
  }
}
